import { bootEpic } from './bootEpic';

export const epics = [bootEpic];
